<template>
  <div class="translation-config-container">
    <translation-tabs />
  </div>
</template>

<script>
import TranslationTabs from './TranslationTabs.vue'

export default {
  name: 'TranslationConfig',
  components: {
    TranslationTabs
  }
}
</script>
